var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorrect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3,8.5l-7.9,7.7l-4.6-4.4c-0.3-0.3-0.8-0.3-1.1,0s-0.3,0.8,0,1.1l5.7,5.4l9-8.7c0.3-0.3,0.3-0.8,0-1.1 C21.1,8.2,20.6,8.2,20.3,8.5z M25,20.1V3.3C25,2,24,1,22.7,1H5.3C4,1,3,2,3,3.3v21.4C3,25.9,4,27,5.3,27h12.8c0.2,0,0.4-0.1,0.5-0.2 l6-5.9c0.2-0.1,0.4-0.4,0.4-0.6C25,20.2,25,20.1,25,20.1z M18.9,24.4c0-1.1,0-2.4,0-2.6c0-0.8,0.1-0.9,0.8-0.9c0.8,0,1.8,0,2.7,0 L18.9,24.4z M23.5,19.5c-1,0-2.7,0-3.8,0c-2.1,0-2.3,1.3-2.3,2.4c0,0.3,0,2.6,0,3.7H5.3c-0.4,0-0.8-0.3-0.8-0.8V3.3 c0-0.4,0.3-0.8,0.8-0.8h17.5c0.4,0,0.8,0.3,0.8,0.8L23.5,19.5L23.5,19.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.560dbfeb.svg";
export { ForwardRef as ReactComponent };